export default {
    shouldShowDHLWarning(shippingProviderProductName) {
        return shippingProviderProductName && shippingProviderProductName.includes("Kleinpaket");
    },
    validPrinterNames: [
        "PRI.LABEL.1",
        "PRI.LABEL.2",
        "PRI.LABEL.4"
    ]
}